import { Component, OnInit } from '@angular/core';
import { EftPaymentService } from '../../feature/contracts-new/modules/reporting/services/eftPayment.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-go-to-connect-account',
  templateUrl: './go-to-connect-account.component.html',
  styleUrls: ['./go-to-connect-account.component.scss']
})
export class GoToConnectAccountComponent implements OnInit {
  icon: string = 'fal fa-external-link-square text-color-green';
  title: string = 'GENERIC.CONNECT_YOUR_ACCOUNT';
  accountLink: string = '';
  isLoading: boolean = true;
  hasError: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private eftPaymentService: EftPaymentService
  ) { }

  get routeParams() {
    return this.route.snapshot.paramMap;
  }

  ngOnInit(): void {
    this.eftPaymentService.getEftPaymentByToken(+this.routeParams.get('eftPaymentId'), this.routeParams.get('securityToken')).subscribe({
      next: response => {
        this.isLoading = false
        this.accountLink = response.paymentUrl;
      },
      error: response => {
        this.isLoading = false
        this.hasError = true;
        this.title = '';
      }
    })
  }

}
